import { render, staticRenderFns } from "./debateHome.vue?vue&type=template&id=79f5ef0c&scoped=true&"
import script from "./debateHome.vue?vue&type=script&lang=js&"
export * from "./debateHome.vue?vue&type=script&lang=js&"
import style0 from "./debateHome.vue?vue&type=style&index=0&id=79f5ef0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5ef0c",
  null
  
)

export default component.exports